import type { EditableCoupon } from "@/resources/coupon";

export const MAX_SEATS = 1000;

export function generateDefaultCoupons(count: number): EditableCoupon[] {
  if (!Number.isInteger(count) || count < 1) return [];
  return Array.from({ length: count }, (_, i) => ({
    couponCode: `id${i + 1}`,
    password: `password${i + 1}`,
  }));
}
